module.exports = __webpack_public_path__ + "3d2a856655defa82493b475af5944367.svg";